import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'activeFilter'
})
export class ActiveFilterPipe implements PipeTransform {
  transform(items: any[], filter: boolean = true): any[] {
    if (!items) {
      return items;
    }

    return items.filter(item => this.applyFilter(item, filter));
  }

  applyFilter(item: any, filter: boolean): boolean {
    if (filter === false) {
      return item.active === false;
    }

    return item.active !== false;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/pipes/activeFilter.pipe.ts